// src/Pages/Dashboard/Dashboard.jsx
import React from "react";

const Dashboard = () => {
  const profile = JSON.parse(localStorage.getItem("profile") || "{}");

  return (
    <>
      <p style={{ marginBottom: "2rem", fontSize: "1.1rem", color: "#475569" }}>
        Welcome back, <strong>{profile.displayName || "User"}!</strong>
      </p>

      <section className="content">
        <div className="card">
          <h3>No of Dealers</h3>
          <p>23</p>
        </div>
        <div className="card">
          <h3>No of Delivery Partners</h3>
          <p>47</p>
        </div>
        <div className="card">
          <h3>No of Tasks</h3>
          <p>112</p>
        </div>
        <div className="card">
          <h3>SLA</h3>
          <p>94 %</p>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
